/**
 * General CMS configuration
 */
var baseConfig = {
	baseUrl:         'https://api.cardiocast.app/',
	apiVersion:      '5.0',
	apiVersionedUrl: 'https://api.cardiocast.app/5.0/',

	clientId: "eAnAByVrvSjIWb6E",
	clientSecret: "HFDy7gaViPEoZO4E78ivR8Z2tHXsb1oo"
};

module.exports = baseConfig;
